import { Home01, ShieldZap } from "@untitledui/icons";
import { useMe } from "@/api/me";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import type { NavItem } from "./sidebar-layout";

export function usePortfolioNavigationSections(): NavItem[] {
  const { data } = useMe();
  const hasSafety = data?.merchants.some((m) => m.features.includes("assurance")) ?? false;

  return [
    { enabled: true, id: "portfolio-overview", label: "Overview", icon: Home01, path: "/portfolio/overview" },
    {
      enabled: hasSafety,
      id: "portfolio",
      label: "Safety",
      icon: ShieldZap,
      description: "See how safe your brands are",
      subItems: [{ id: "portfolio-safety", label: "Safety Overview", icon: ShieldZap, path: "/portfolio-safety" }],
    },
  ];
}

export function useWorkspacePortfolioNavigationSections(): NavItem[] {
  const { workspace } = useWorkspaceAdmin();
  const hasSafety = workspace?.merchants.some((m) => m.features.includes("assurance")) ?? false;

  return [
    {
      enabled: true,
      id: "workspace-portfolio-overview",
      label: "Overview",
      icon: Home01,
      path: "/workspace/$workspaceId/portfolio/overview",
    },
    {
      enabled: hasSafety,
      id: "workspace-portfolio",
      label: "Safety",
      icon: ShieldZap,
      description: "See how safe your brands are",
      subItems: [
        {
          id: "workspace-portfolio-safety",
          label: "Safety Overview",
          icon: ShieldZap,
          path: "/workspace/$workspaceId/portfolio/safety",
        },
      ],
    },
  ];
}
